import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useTheme } from '../../context/ThemeContext';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  // Start with sidebar collapsed by default
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className={`flex h-screen w-full ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'} font-extralight`} data-id="element-283">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} data-id="element-284" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-285">
        <Header toggleSidebar={toggleSidebar} data-id="element-286" />
        <main className="flex-1 overflow-auto relative" data-id="element-287">
          <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/10 dark:to-black/30 pointer-events-none" data-id="element-288" />
          {children}
        </main>
      </div>
    </div>;
};
export default Layout;